<template>
    <div>
        <div style="width: 100%;overflow-x: hidden;">
            <div class="banner">
                <div style="margin-top: 86px;margin-left: 10%;">
                    <div class="banner-text1">
                        <span>首页</span>&nbsp;>&nbsp;<span>互认标准</span>&nbsp;>&nbsp;<span>常见问题</span>
                    </div>

                    <div class="banner-text2" style="margin-top: 30px;">常见问题</div>

                </div>
            </div>

            <div class="box6">
                <div class="navbox">
                    <div v-for="(item, index) in tabsList" :key="index" class="nav" :class="{ active: item.isActive }"
                        @click="toggleActive(item)" @mouseover="item.isHovered = true"
                        @mouseout="item.isHovered = false">
                        <div class="navText">
                            <span>{{ item.name }}</span>
                            <div class="indicator" v-show="item.isActive"></div>
                        </div>
                    </div>



                </div>
                <div class="line1"></div>


                <el-collapse v-model="activeNames" @change="handleChange" style="margin-top: 0px;">
                    <el-collapse-item title="如何查看TOS账单？" name="1">
                        <div>与现实生活一致：与现实生活的流程、逻辑保持一致，遵循用户习惯的语言和概念；</div>
                        <div>在界面中一致：所有的元素和结构需保持一致，比如：设计样式、图标和文本、元素的位置等。</div>
                    </el-collapse-item>
                    <el-collapse-item title="TOS支持哪些类型的资源包？" name="2">
                        <div>控制反馈：通过界面样式和交互动效让用户可以清晰的感知自己的操作；</div>
                        <div>页面反馈：操作后，通过页面元素的变化清晰地展现当前状态。</div>
                    </el-collapse-item>
                    <el-collapse-item title="资源包支持退款吗？" name="3">
                        <div>简化流程：设计简洁直观的操作流程；</div>
                        <div>清晰明确：语言表达清晰且表意明确，让用户快速理解进而作出决策；</div>
                        <div>帮助用户识别：界面简单直白，让用户快速识别而非回忆，减少用户记忆负担。</div>
                    </el-collapse-item>
                    <el-collapse-item title="如何关闭TOS服务？" name="4">
                        <div>用户决策：根据场景可给予用户操作建议或安全提示，但不能代替用户进行决策；</div>
                        <div>结果可控：用户可以自由的进行操作，包括撤销、回退和终止当前操作等。</div>
                    </el-collapse-item>
                </el-collapse>


            </div>


            <div class="pagination">
                <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
                    :page-sizes="[100, 200, 300, 400]" layout="prev, pager, next,sizes," :total="1000"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
            <div class="bottom">

            </div>

           

        </div>
    </div>
</template>

<script lang='ts' setup>
import { reactive, toRefs, ref } from 'vue'


let tabsList = ref([
    { name: '政策业务', isHovered: false, isActive: true, },
    { name: '标准规范', isHovered: false, isActive: false, },
    { name: '互认接入', isHovered: false, isActive: false, },
    { name: '技术对接', isHovered: false, isActive: false, },
    { name: '操作使用', isHovered: false, isActive: false, },
    { name: '其他', isHovered: false, isActive: false, },
])
let activeName = ref('1')
const toggleActive = (item: any) => {
    tabsList.value.map((item: any) => {
        item.isActive = false;
    })

    item.isActive = true;
    activeName.value = item.value
}

let currentPage = ref(1)
let pageSize = ref(100)

</script>
<style lang="scss" scoped>
.banner {
    width: 100%;
    height: 300px;
    position: relative;
    background: url('../assets/img/asked/banner-bg.png') no-repeat center center;
    background-size: cover;
    margin-top: 88px;
    padding: 1px;

    .banner-text1 {
        color: #525760;
        
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
    }

    .banner-text2 {
        color: #23252B;
        
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 54px;
    }
}

.news-content {
    width: 80%;
    min-width: 1200px;
    height: 100%;
    display: flex;
    margin: 0 auto;

    .left {
        width: 74%;
        height: 100%;

        .title {
            color: #23252B;
            
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 56px;
            width: 90%;
            margin: 0 auto;
        }

        .news-box {
            display: flex;
            width: 90%;
            justify-content: space-between;
            align-items: center;
            padding: 12px 0;
            margin-left: 50px;

            .news-title {
                width: 70%;
                color: #23252B;
                
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 27px;
                cursor: pointer;
            }

            .news-time {
                color: var(--Color-Neutral-neutral-9, #969AA0);
                
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 21px;

            }
        }
    }

    .right {
        width: 25%;
        height: 100%;
        margin-top: 80px;

        .title {
            color: #000;
            
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 27px;
            /* 150% */
        }

        .content {
            width: 100%;
            height: 300px;
            border-radius: var(--Radius-Border-radius-4, 8px);
            background: #F7F8FA;
            margin-top: 15px;
            display: flex;
            padding: 32px 32px 44px 32px;
            flex-direction: column;
            align-items: flex-start;
            align-self: stretch;

            .news-item {
                color: #000;
                
                font-size: 14px;
                font-style: normal;
                font-weight: 400;
                line-height: 21px;
            }


        }
    }

}




.bottom {
    width: 58%;
    height: 80px;
    background: url('../assets/img/news/bottom.png') no-repeat center center;
    background-size: cover;
    border-radius: var(--Radius-Border-radius-4, 8px);
    margin-left: 10%;
    margin-top: 80px;
    cursor: pointer;

}

.pagination {
    width: 58%;
    height: 80px;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    margin-top: 30px;

}




.news-detail-title {
    color: #333;
    font-family: Inter;
    font-size: 38px;
    font-style: normal;
    font-weight: 400;
    line-height: 56px;
}



.navbox {
    width: 80%;
    display: flex;
    margin-top: 50px;


}

.nav {
    /* width: 100%; */
    white-space: nowrap;
    padding: 0 50px 0 50px;
    color: var(--text-color-primary, #303133);
    text-align: center;
    color: #23252B;
    
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 56px;

}

.navText {
    position: relative;
}

.nav:hover {
    cursor: pointer;
    /* 鼠标移入时变为小手 */
    color: #3461FF;
    /* 文字变为蓝色 */
}

.nav.active {
    color: #3461FF;
    /* 文字变为蓝色 */
}

.indicator {
    width: 100%;
    border: 1px solid #3461FF;
    position: absolute;
    bottom: -10px;
}

.nav.active .indicator {
    opacity: 1;
    /* 选中时指示器不透明度为1 */
}

.line1 {
    border-bottom: 1px solid var(--Color-Auxiliary-auxiliary-2, #D7D7DC);
    width: 100%;
    margin: 0 auto;
    margin-top: 9px;
}

:deep(.el-pager li) {
    border: 1px solid rgb(230, 223, 230);
    margin: 0 5px;
}

:deep(.el-pager li.is-active) {
    border: 1px solid #409eff;
    font-weight: normal !important;
}
.box6 {
    width: 80%;
    margin: 0 auto;
    min-width: 1200px;


}
</style>